import React from "react"
import PropTypes from "prop-types"
import Link from "components/elements/link"
import { CallToActionProps } from "components/blocks/callToAction"
import "./card.scss"

const Card = ({ action, description, index }) =>
  description.description && (
    <Link className="custome-card-link" to={action.action.url}>
      <div className="card-content">
        <div className="step">{`Step ${index + 1}`}</div>
        {description.description}
      </div>
    </Link>
  )

export const CardProps = {
  action: PropTypes.shape(CallToActionProps),
  description: PropTypes.shape({
    description: PropTypes.string,
  }),
}

Card.propTypes = {
  ...CardProps,
  index: PropTypes.number,
}

export default Card
